import DeviceRegistryClient from 'IhmDeviceRegistryServiceLambda-coral-javascript-clients/jquery-client'
import { EnvironmentDetail, ServiceClient } from '@amzn/ihm-associate-tools-js-lib'
import { AuthenticatedRequestHandler, IAuthenticatedRequestHandlerResponse } from '@api/utils/AuthenticatedRequestHandler'
/**
 * DeviceRegistryServiceClient
 * This client is responsible for calling the IhmDeviceRegistryService for registerDevice and updateDevice API using AuthenticatedRequestHandler
 * Package: https://code.amazon.com/packages/IhmDeviceRegistryServiceLambdaModel/trees/mainline
 */

export class DeviceRegistryServiceClient {
    private static _instance: DeviceRegistryClient
    private readonly client: any
    private readonly endpoint: string

    public static getInstance (): DeviceRegistryServiceClient {
        if (!DeviceRegistryServiceClient._instance) {
            DeviceRegistryServiceClient._instance = new DeviceRegistryServiceClient()
        }
        return DeviceRegistryServiceClient._instance
    }

    /**
     * Register device endpoint mapping to DeviceRegistryService.
     */
    public async registerDevice (request) {
        if (!request || !request.userInformation || !request.userInformation.storeId) {
            console.warn('DeviceRegistryServiceClient: registerDevice called with bad request data')
        }
        console.info('ATBase DeviceRegistryServiceClient registerDevice: ',JSON.stringify(this.client))
        console.info('ATBase DeviceRegistryServiceClient registerDevice request data: ',JSON.stringify(request))
        const response = await this.sendRequest({
            url: this.endpoint + 'register/',
            method: 'POST',
            headers: {
                'authority': 'dev.ihmdeviceregistry.jihmcdo.com',
                'X-Amz-Target': 'com.amazon.ihmdeviceregistry.RegisterDevice',
                'Content-Encoding': 'amz-1.0',
                'Content-Type': 'application/json; charset=UTF-8',
            },
            body: request,
        })
        console.info('ATBase DeviceRegistryServiceClient registerDevice API resp : ',JSON.stringify(response))
        return response
    }

    /**
     * Update device endpoint mapping to DeviceRegistryService.
     */
    public async updateDevice (request) {
        if (!request || !request.userUpdateInformation || !request.userUpdateInformation.storeId) {
            console.warn('DeviceRegistryServiceClient: updateDevice called with bad request data')
        }
        console.info('ATBase deviceRegistryServiceClient updateDevice: ',JSON.stringify(this.client))
        console.info('ATBase DeviceRegistryServiceClient updateDevice request data: ',JSON.stringify(request))
        const response = await this.sendRequest({
            url: this.endpoint + 'update/',
            method: 'POST',
            headers: {
                'authority': 'dev.ihmdeviceregistry.jihmcdo.com',
                'X-Amz-Target': 'com.amazon.ihmdeviceregistry.UpdateDevice',
                'Content-Encoding': 'amz-1.0',
                'Content-Type': 'application/json; charset=UTF-8',
            },
            body: request,
        })
        return response
    }

    /**
     * Makes the call to the abstract authenticatedRequestsClient.
     * @param options call parameters.
     * @returns {*} Output from the call (from the underlying service)
     */
    private async sendRequest (options): Promise<IAuthenticatedRequestHandlerResponse> {
        console.log('ATBase: DeviceRegistryServiceClient authenticatedRequestsService sendRequest')
        return AuthenticatedRequestHandler.raw(options)
    }

    /**
     * Private Constructor setting the DeviceRegistry client and its endpoint
     * @private
     */
    private constructor () {
        this.client = DeviceRegistryClient
        this.client.config.overrideDomain(EnvironmentDetail.getDomain())
        this.client.config.overrideRealm(EnvironmentDetail.getRealm())
        this.endpoint = this.client.config.endpoint()
        console.log('ATBase: DeviceRegistryServiceClient endpoint: ', this.endpoint)
    }

}
